import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Actions } from '../../models/itens.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-itens-critical-actions',
  templateUrl: './itens-critical-actions.component.html',
  styleUrls: ['./itens-critical-actions.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensCriticalActionsComponent extends BaseFormComponent<Actions> implements OnInit {
  @Input() formArray: FormArray = null;
  @Input() currentItem: object[] = [];
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);

  }

  ngOnInit() {
  }

}
